import { useEffect } from 'react';
import {
  applyLoungeThemeClasses,
  isLoungeDarkModeEnabled,
  isModernLoungeEnabled,
  syncInAppBodyClass,
} from '../utils/loungeTheme';

export const shouldHideModernThemeBanner = (pathname: string) =>
  /^\/disneyland\/user\/[^/]+\/mypost\/?$/.test(pathname);

export const ModernThemeBanner = () => {
  const hiddenForRoute = shouldHideModernThemeBanner(window.location.pathname);

  useEffect(() => {
    const isOn = isModernLoungeEnabled();
    const isDarkOn = isLoungeDarkModeEnabled();
    // Body-level class so styles for body-portaled UI (react-modal,
    // react-burger-menu) can scope themselves under `body.mw-modern-mode`
    // and remain inert when the user has opted out.
    applyLoungeThemeClasses(isOn, isDarkOn);
    syncInAppBodyClass();
  }, []);

  if (hiddenForRoute) {
    return null;
  }

  return null;
};

export default ModernThemeBanner;
